/* eslint class-methods-use-this: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, DropdownButton, MenuItem, Row, Col, Glyphicon } from 'react-bootstrap';
import _ from 'underscore';
import moment from 'moment';

import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import { withTranslation } from 'react-i18next';

const cancelReasons = [
  { value: 'Duplicate', localizationSlug: 'DUPLICATE' },
  { value: 'Re-Schedule', localizationSlug: 'RESCHEDULE' },
  { value: 'Customer Mistake', localizationSlug: 'CUSTOMER_MISTAKE' },
  { value: 'Customer Request', localizationSlug: 'CUSTOMER_REQUEST' },
]

class CancelOrderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: null,
    };
  }

  handleCancelOrder = () => {
    OrdersActionCreators.cancelOrder(this.props.order._id, this.state.reason);
    this.setState({ reason: null }, () => {
      this.props.onHide();
    });
  }

  renderCancelButton() {
    const { t } = this.props;
    return (
      <DropdownButton
        title={ this.state.reason || t("CANCELLATION_REASON") }
        id="cancel-bg-nested-dropdown"
      >
        {cancelReasons.map((reason, i) => (
          <MenuItem
            key={reason.value}
            eventKey={reason.value}
            onSelect={key => this.setState({reason: key})}
          >
            {t(reason?.localizationSlug)}
          </MenuItem>
        ))}
      </DropdownButton>
    );
  }

  render() {
    if (!this.props.order) return null;
    const { t } = this.props;
    return (
      <Modal show={this.props.show} onHide={() => this.props.onHide()}>
        <Modal.Header closeButton>
          <Modal.Title>
            {t('CANCEL_ORDER_WITH_ORDER_ID', { orderId: this.props?.order?.order_id })}
          </Modal.Title>
        </Modal.Header>
				<Modal.Body>
          <Row style={{marginBottom:10}}>
            <Col xs={12}>
              {t('CANCEL_ORDER_NOTE')}
            </Col>
          </Row>
					<Row>
						<Col xs={12}>
							{this.renderCancelButton()}
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Row>
						<Col xs={8}></Col>
						<Col xs={4}>
              <Button
                disabled={!this.state.reason}
                onClick={this.handleCancelOrder}
                style={{
                  marginRight: '5',
                  fontSize: '.875rem',
                  fontWeight: '700',
                  borderRadius: '.25rem',
                }}
                bsStyle="danger"
              >
                {t('CANCEL_ORDER')}
              </Button>
						</Col>
					</Row>
				</Modal.Footer>
			</Modal>
    );
  }
}
export default withTranslation()(CancelOrderModal);